import { render, staticRenderFns } from "./TableOtherObject.vue?vue&type=template&id=a6364e46&scoped=true&"
import script from "./TableOtherObject.vue?vue&type=script&lang=js&"
export * from "./TableOtherObject.vue?vue&type=script&lang=js&"
import style0 from "./TableOtherObject.vue?vue&type=style&index=0&id=a6364e46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6364e46",
  null
  
)

export default component.exports